/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const DrowsinessIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.7 12.2 12.2 1.8 25 1.8S48.2 12.2 48.2 25 37.8 48.2 25 48.2z' />
			<path d='M25.8 26.8c-.1 0-.1 0 0 0-3.5 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2S32 36.4 32 33c-.1-3.4-2.8-6.2-6.2-6.2zM25.7 37c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM36 17.1zM36 17.1c-.4 0-.7.3-.7.7 0 .6-.2 1.3-.6 1.8-.7.6-1.7.6-2.5.1-.4-.5-.6-1.1-.7-1.7 0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 1 .4 1.9 1.1 2.7 1.3 1.1 3.2 1.1 4.4-.1.6-.8 1-1.7 1-2.7 0-.5-.3-.8-.6-.8zM19 17.5c-.4 0-.7.3-.7.7 0 .6-.2 1.3-.6 1.8-.7.6-1.7.6-2.5.1-.4-.5-.6-1.1-.7-1.7 0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7 0 1 .4 1.9 1.1 2.7 1.3 1.1 3.2 1.1 4.4-.1.6-.8 1-1.7 1-2.7.1-.5-.2-.8-.6-.8z' />
		</svg>
	)
}

export default DrowsinessIcon
